import { useCallback, useState } from 'react';

import { useSelectUserWithHiddenRefetch } from '../../../../hooks/user/useSelectUserWithUpdate';
import { UserData } from '../../../../types/users';
import { SearchPatientFormProps, SearchPatientKeys } from './SearchPatientForm';
import { SearchPatientListProps } from './SearchPatientList';

export const useSearchAndSelectPatient = ({
  onPatientSelect,
}: { onPatientSelect?: (user: UserData | undefined) => void } = {}) => {
  const { setSelectedUser: setSelectedPatient, selectedUser: selectedPatient } =
    useSelectUserWithHiddenRefetch();

  const [searchPatientKeys, setSearchPatientKeys] =
    useState<SearchPatientKeys>();

  const isSearchingPatients = !!searchPatientKeys;

  const selectPatient = useCallback(
    (user: UserData | undefined) => {
      setSearchPatientKeys(undefined);
      setSelectedPatient(user);
      onPatientSelect && onPatientSelect(user);
    },
    [setSelectedPatient, onPatientSelect],
  );

  const clearSelectedPatient = useCallback(() => {
    selectPatient(undefined);
  }, [selectPatient]);

  const showPatientSearch = useCallback(
    (searchPatientKeys: SearchPatientKeys) => {
      selectPatient(undefined);
      setSearchPatientKeys(searchPatientKeys);
    },
    [selectPatient],
  );

  return {
    isSearchingPatients,
    selectPatient,
    selectedPatient,
    searchPatientFormProps: {
      selectedPatient,
      clearSelectedPatient,
      showPatientSearch,
    } satisfies SearchPatientFormProps,
    searchPatientListProps: {
      searchPatientKeys,
      selectPatient,
    } satisfies SearchPatientListProps,
  };
};
